import { featureFlagKeys } from '../common/drawers/featureFlagDrawer/const/featureFlagKeys';
import { isAuthenticated, withFeatureFlag } from '../common/permissions';
import { MultiSiteDashboard } from './MultiSiteDashboard';
import SingleSiteDashboard from './SingleSiteDashboard';

export default [
  {
    exact: true,
    path: '/home',
    helpId: 'dashboard',
    permissions: [isAuthenticated],
    component: SingleSiteDashboard,
  },
  {
    exact: true,
    path: '/home/multisite-beta',
    helpId: 'dashboard',
    permissions: [
      isAuthenticated,
      withFeatureFlag(featureFlagKeys.isMultisiteFunctionalityAvailable),
    ],
    component: MultiSiteDashboard,
  },
];
